export const environment = {
  // URL del backend
  backendUrl: 'https://danielherrerorey.com/dhr/backend/',
   // Backend python flask
  backendPythonFlaskUrl: 'https://danielherrerorey.com/dhr/python/',
   // Backend typescript fastify
  backendTypescriptFastifyUrl: 'https://danielherrerorey.com/dhr/fastify/',
  // Url de la paas
  wsUrl: 'wss://rest-rpcnode1-ws-blockchain-desa.apps.ocp4-d.redsys.es',
  rpcUrl: 'http://rest-rpcnode1-blockchain-desa.apps.ocp4-d.redsys.es',
  svaUrl:
    'https://rest-blkchsva-blockchain-desa.apps.ocp4-d.redsys.es/olimpoRuntimeOnline/RestService/v2',
  repUrl:
    'https://rest-blckhrep-blockchain-desa.apps.ocp4-d.redsys.es/olimpoRuntimeOnline/RestService/v2',
  scAddresses: {
    Validadores: '0x0000000000000000000000000000000000007777',
    Liquidacion: '0x0000000000000000000000000000000000007778',
    Permissions: '0x0000000000000000000000000000000000008888',
    NodePermissions: '0x0000000000000000000000000000000000008889',
    Lottery: '0x3Ace09BBA3b8507681146252d3Dd33cD4E2d4F63',
    RDSToken: '0xBF921f94Fd9eF1738bE25D8CeCFDFE2C822c81B0',
    COMToken: '0xBeC8a9e485a4B75d3b14249de7CA6D124fE94795',
  },
  private_key:
    '8f2a55949038a9610f50fb23b5883af3b4ecb3c3bb792cbcefbd1542c692be63',
  ws_ping_interval: 60000,
  eventos_historicos_num_bloques: 1000,
  // para leer eventos historicos en x tandas de x bloques
  eventos_historicos_tandas: 2,
  delay_before_call_sva_get_operation: 3000,
  interceptor_cache_habilitado: false,
  explorador_cache_bloques: 5000,
  // Numero de transacciones antiguas a cargar
  explorador_num_transacciones_historico: 1000,
  // Numero de confirmaciones de transacciones antiguas a cargar
  explorador_num_receipts_historico: 1000,
  // Timeout para quitar snackbar messages (toast)
  snackbar_time_dismiss: 10000,
  // Maximo numero de transacciones pendientes a cargar
  explorador_max_transacciones_pendientes: 100,
  // Numero maximo de cuentas de usuario y SC a escanear
  explorador_max_cuentas: 1000,
  // Liquidacoin. Numero de operaciones pendientes a recuperar en cada tanda
  liquidacion_dame_operaciones_pendientes_tanda: 10,
  // Tiempo de refresco de la pagina de nodos en ms
  nodos_refresco_tiempo: 5000,
  // Al llegar un nuevo numero de bloque, tiempo a esperar para recuperar el bloque en ms
  explorador_bloques_interval: 1000,
  // Indica si el backend dispone de rpc extendido para plugins
  exporador_api_plugin_extendido: false,
  // Direcciones de los validadores
  validadores: [
    {
      nombre: 'validator1',
      address: 'https://rest-validator1-blockchain-desa.apps.ocp4-d.redsys.es',
    },
    {
      nombre: 'validator2',
      address: 'https://rest-validator2-blockchain-desa.apps.ocp4-d.redsys.es',
    },
    {
      nombre: 'validator3',
      address: 'https://rest-validator3-blockchain-desa.apps.ocp4-d.redsys.es',
    },
    {
      nombre: 'validator4',
      address: 'https://rest-validator4-blockchain-desa.apps.ocp4-d.redsys.es',
    },
    {
      nombre: 'validator5',
      address: 'https://rest-validator5-blockchain-desa.apps.ocp4-d.redsys.es',
    },
  ],
  // reset smart contact borrado por tanda
  liquidacion_limpiar_tanda: 10,
  // Indica si el backend es besu, para omitir llamadas solo disponibles en besu
  explorador_backend_es_besu: true,
  simulatorUrl: undefined,
  nombre_entidad_a: 'Ent. A',
  nombre_entidad_b: 'Ent. B',

  accessManager: {
    url: 'https://acceso-d.redsys.es/auth',
    realm: 'blockchain',
    clientId: 'blockchain-front',
  },

  userRolesApp: {
    admin: 'admin',
    entidadAdmin: 'entidad-admin',
    entidad: 'entidad',
    operador: 'operador',
    desbloqueo: 'desbloqueo',
    gestionValidadores: 'gestion-validadores',
    liqDiscrepancia: 'liq-discrepancia',
    liqSimulacion: 'liq-simulacion',
    nodos: 'nodos',
    explorador: 'explorador',
    permisionado: 'permisionado',
    backend: 'backend',
  },

  ssoEnable: true,

  //Configuracion roles usuarios en base a rutas
  userRolesConfig: {
    admin: {
      lateralMenuConfig: [
        {
          title: 'Listado Modulos',
          icon: 'grid-outline',
          link: '/listado-modulos',
        },
        {
          title: 'Listado CIERS',
          icon: 'shuffle',
          children: [
            {
              title: 'Adquirientes',
              link: '/listado-ciers/adquirientes',
              icon: 'log-in-outline',
            },
            {
              title: 'Resolutores',
              link: '/listado-ciers/resolutores',
              icon: 'log-out-outline',
            },
          ],
        },
      ],
      allowedRoutes: ['^/listado-modulos$', '^/listado-ciers$', '^/profile$'],
    },
  },
  keycloakUrlPattern: /^.*$/,
};
